import React, { useEffect } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import SEO from '../../SEO';
import { useAuth } from '../../../context/AuthContext';
import DashboardLayout from '../shared/DashboardLayout';
import { INVESTOR_NAV, INVESTOR_TITLES } from './nav';

export default function InvestorLayout() {
  const { user, logout, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!authLoading && !user) navigate('/login');
    if (user && user.role !== 'INVESTOR') {
      if (['ADMIN', 'SUB_ADMIN'].includes(user.role)) navigate('/admin');
      else if (user.role === 'STARTUP_FOUNDER') navigate('/founder-dashboard');
      else if (user.role === 'CXO') navigate('/mentor-dashboard');
      else navigate('/login');
    }
  }, [user, authLoading, navigate]);

  if (authLoading || !user) return null;

  return (
    <>
      <SEO title="Investor Portal" description="InnovHer investor dealflow portal." />
      <DashboardLayout
        brand="Investor Portal"
        subtitle="Dealflow"
        navItems={INVESTOR_NAV}
        user={user}
        onLogout={() => { logout(); navigate('/login'); }}
        getTitle={() => INVESTOR_TITLES[location.pathname] || 'Investor Portal'}
      >
        <Outlet />
      </DashboardLayout>
    </>
  );
}
